var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "client-contact-email-body" },
    [
      _c("div", { staticClass: "choose-event-wrapper row" }, [
        _c("div", { staticClass: "col-md-3" }, [
          _c("div", { staticClass: "h3-text" }, [_vm._v("Event Type")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "select-type-event" },
            [
              _c(
                "pretty-radio",
                {
                  staticClass: "custom-radio-btn p-default p-round text-label",
                  attrs: { name: "isSingleEvent", value: true },
                  model: {
                    value: _vm.isSingleEvent,
                    callback: function($$v) {
                      _vm.isSingleEvent = $$v
                    },
                    expression: "isSingleEvent"
                  }
                },
                [_vm._v("This single event")]
              ),
              _vm._v(" "),
              _c(
                "pretty-radio",
                {
                  staticClass: "custom-radio-btn p-default p-round text-label",
                  attrs: { name: "isSingleEvent", value: false },
                  model: {
                    value: _vm.isSingleEvent,
                    callback: function($$v) {
                      _vm.isSingleEvent = $$v
                    },
                    expression: "isSingleEvent"
                  }
                },
                [
                  _vm._v("Related Events "),
                  _vm.event.relatedEvents.length > 0
                    ? _c("span", { staticClass: "event-count" }, [
                        _vm._v(
                          "(" + _vm._s(_vm.event.relatedEvents.length) + ")"
                        )
                      ])
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-9" }, [
          _c("div", { staticClass: "h3-text" }, [_vm._v("Events")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "group-related-events" },
            [
              _vm.isSingleEvent == true
                ? _c("div", { staticClass: "related-event-item" }, [
                    _c(
                      "div",
                      {
                        staticClass: "event-name",
                        on: {
                          click: function($event) {
                            _vm.relatedEventItemClick(_vm.event.id)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.event.eventName))]
                    )
                  ])
                : _vm._l(_vm.event.relatedEvents, function(reEvent) {
                    return _c(
                      "div",
                      { key: reEvent.id, staticClass: "related-event-item" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "event-name",
                            on: {
                              click: function($event) {
                                _vm.relatedEventItemClick(reEvent.id)
                              }
                            }
                          },
                          [_vm._v(_vm._s(reEvent.eventName))]
                        )
                      ]
                    )
                  })
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "recipients-wrapper row" }, [
        _c("div", { staticClass: "recipients-section col-md-6" }, [
          _c("div", { staticClass: "h3-text text-mar-bot" }, [
            _vm._v("Recipients")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "list-email-recipient" }, [
            _c("div", { staticClass: "ap-input-wrapper" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.recipientEmail,
                    expression: "recipientEmail"
                  }
                ],
                staticClass: "ap-input",
                attrs: { type: "text", placeholder: "Enter email address" },
                domProps: { value: _vm.recipientEmail },
                on: {
                  keyup: function($event) {
                    if (
                      !("button" in $event) &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.addRecipientTo($event)
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.recipientEmail = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "add-icon",
                on: { click: _vm.addRecipientTo }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "list-email-send-to" },
              _vm._l(_vm.listEmailSendTo, function(e) {
                return _c("div", { key: e, staticClass: "email-item" }, [
                  _c("div", { staticClass: "text" }, [_vm._v(_vm._s(e))]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "remove-icon",
                    on: {
                      click: function($event) {
                        _vm.removeRecipient(e)
                      }
                    }
                  })
                ])
              })
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "cc-section col-md-6" }, [
          _c("div", { staticClass: "h3-text text-mar-bot" }, [
            _vm._v("Additional Recipients (CC)")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "list-email-recipient" }, [
            _c("div", { staticClass: "ap-input-wrapper" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.ccEmail,
                    expression: "ccEmail"
                  }
                ],
                staticClass: "ap-input",
                attrs: { type: "text", placeholder: "Enter email address" },
                domProps: { value: _vm.ccEmail },
                on: {
                  keyup: function($event) {
                    if (
                      !("button" in $event) &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.addRecipientCC($event)
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.ccEmail = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "add-icon",
                on: { click: _vm.addRecipientCC }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "list-email-send-to" },
              _vm._l(_vm.listEmailCC, function(e) {
                return _c("div", { key: e, staticClass: "email-item" }, [
                  _c("div", { staticClass: "text" }, [_vm._v(_vm._s(e))]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "remove-icon",
                    on: {
                      click: function($event) {
                        _vm.removeRecipientCC(e)
                      }
                    }
                  })
                ])
              })
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "h3-text text-send-email" }, [
        _vm._v("Send Email")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "send-email-container" }, [
        _c("div", { staticClass: "col-6 participant-emails" }, [
          _c(
            "div",
            { staticClass: "text-entry-field-wrapper w-100" },
            [
              _c("span", { staticClass: "text-entry-title" }, [
                _vm._v("Email Template")
              ]),
              _vm._v(" "),
              _c("multiselect", {
                staticClass: "multiple-select-work-group",
                attrs: {
                  options: _vm.emailTemplates,
                  placeholder: "Choose Email Type",
                  label: "templateTypeName",
                  openDirection: "below",
                  "allow-empty": false,
                  "show-labels": false
                },
                on: { select: _vm.onSelectEmailTemplate },
                model: {
                  value: _vm.emailTemplate,
                  callback: function($$v) {
                    _vm.emailTemplate = $$v
                  },
                  expression: "emailTemplate"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "text-entry-field-wrapper mt-3 w-100" }, [
            _c("span", { staticClass: "text-entry-title" }, [
              _vm._v("Subject Line")
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.emailTemplate.emailSubject,
                  expression: "emailTemplate.emailSubject"
                }
              ],
              staticClass: "text-subject",
              attrs: { type: "text", placeholder: "Enter email subject line" },
              domProps: { value: _vm.emailTemplate.emailSubject },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.emailTemplate,
                    "emailSubject",
                    $event.target.value
                  )
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-entry-field-wrapper mt-3" },
            [
              _c("span", { staticClass: "text-entry-title" }, [
                _vm._v("Email body")
              ]),
              _vm._v(" "),
              _c("vue-ckeditor", {
                attrs: { config: _vm.config },
                on: { input: _vm.onChangeTemplate },
                model: {
                  value: _vm.emailTemplate.body,
                  callback: function($$v) {
                    _vm.$set(_vm.emailTemplate, "body", $$v)
                  },
                  expression: "emailTemplate.body"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-6" }, [
          _c("div", { staticClass: "email-template-wrapper" }, [
            _c("div", { staticClass: "reply-and-history-section w-100" }, [
              _c("div", { staticClass: "reply-emails-wrapper" }, [
                _c("div", { staticClass: "text-entry-title" }, [
                  _vm._v("Reply emails go to:")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "list-email-recipient" }, [
                  _c("div", { staticClass: "ap-input-wrapper" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.replyEmail,
                          expression: "replyEmail"
                        }
                      ],
                      staticClass: "ap-input",
                      attrs: {
                        type: "text",
                        placeholder: "Enter email address"
                      },
                      domProps: { value: _vm.replyEmail },
                      on: {
                        keyup: function($event) {
                          if (
                            !("button" in $event) &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.addReplyEmailGoTo($event)
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.replyEmail = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "add-icon",
                      on: { click: _vm.addReplyEmailGoTo }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "list-email-send-to" }, [
                    _vm.listReplyEmails != ""
                      ? _c("div", { staticClass: "email-item" }, [
                          _c("div", { staticClass: "text" }, [
                            _vm._v(_vm._s(_vm.listReplyEmails))
                          ]),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "remove-icon",
                            on: {
                              click: function($event) {
                                _vm.removeRecipientReply(_vm.listReplyEmails)
                              }
                            }
                          })
                        ])
                      : _vm._e()
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "email-history-wrapper" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "list-email-recipient" }, [
                  _c("div", { staticClass: "email-history-title col-md-12" }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        {
                          staticClass: "caption-text sent-date col-md-5",
                          on: {
                            click: function($event) {
                              _vm.setSortOption("time")
                            }
                          }
                        },
                        [
                          _vm._v("Sent Date\n                    "),
                          _c("Icon", {
                            staticClass: "sort-icon",
                            attrs: { name: "sort" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "line" }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "caption-text email-template col-md-5",
                          on: {
                            click: function($event) {
                              _vm.setSortOption("template")
                            }
                          }
                        },
                        [
                          _vm._v("Email Template\n                    "),
                          _c("Icon", {
                            staticClass: "sort-icon",
                            attrs: { name: "sort" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-3" })
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "list-email-send-to" },
                    _vm._l(_vm.listHistory, function(h) {
                      return _c(
                        "div",
                        { key: h, staticClass: "history-item" },
                        [
                          _c("div", { staticClass: "history-left" }, [
                            _c("div", { staticClass: "sent-date" }, [
                              _vm._v(_vm._s(_vm._f("dateFormatMMDDYY")(h.time)))
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "email-template" }, [
                              _vm._v(_vm._s(_vm._f("templateName")(h.template)))
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "view-detail",
                              on: {
                                click: function($event) {
                                  _vm.goToEmailHistoryDetails(h.id)
                                }
                              }
                            },
                            [_vm._v("View details")]
                          )
                        ]
                      )
                    })
                  )
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btn-container" },
        [
          _c(
            "b-button",
            { staticClass: "btn-cancel", on: { click: _vm.onCancel } },
            [_vm._v("\n      Cancel\n    ")]
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "btn-send",
              attrs: { disabled: _vm.isSendLoading },
              on: { click: _vm.sendEmailClick }
            },
            [
              _vm.isSendLoading
                ? _c("b-spinner", { attrs: { variant: "primary" } })
                : _vm._e(),
              _vm._v("\n      Send\n    ")
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("ModalChangeEmailTemplate", {
        on: {
          CLOSE_MODAL_CHANGE_TEMPLATE_ACTION: _vm.closeModalChangeMailTemplate
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "email-history-text-wrapper" }, [
      _c("div", { staticClass: "email-history-text text-entry-title" }, [
        _vm._v("Email History")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e811757a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e811757a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/events/ClientContactEmail.vue
// module id = 1682
// module chunks = 1